import { useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const usePatientMedicalHistoryByConsultation = (consultationId) => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["patientMedicalHistory", "consultation", consultationId],
    queryFn: async () => {
      if (!consultationId) return [];
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/patientmedicalhistory/getbyconsultation/${consultationId}`
      );
      return response.data;
    },
    enabled: !!consultationId,
  });
};

export const useCreatePatientMedicalHistory = () => {
  const queryClient = useQueryClient();
  const handleNetworkError = useHandleNetworkError();

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (data) => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/patientmedicalhistory`,
        data
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["patientMedicalHistory"] });
      queryClient.invalidateQueries({
        queryKey: ["consultation"],
      });
    },
    onError: handleNetworkError,
  });
};

export const useDeletePatientMedicalHistory = () => {
  const queryClient = useQueryClient();
  const handleNetworkError = useHandleNetworkError();

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async ({ id }) => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.delete(
        `${tenantVal}/patientmedicalhistory/delete`,
        { data: { id } }
      );
      return response.data;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [
          "patientMedicalHistory",
          "consultation",
          variables.consultationId,
        ],
      });
    },
    onError: handleNetworkError,
  });
};
